import { defineCustomElement, provide } from "vue";
import PcSearchComponent from "./PcSearchComponent.vue";
import MobileSearchComponent from "./MobileSearchComponent.vue";
import { Services } from "../services/services";

export class VueWebAppService {
    constructor(private _services: Services) {}

    public async initSearchModule() {
        const searchHealth = await this._services.searchApiService().searchAutocompleteHealthcheck();
        if (searchHealth?.response?.data?.health) {
            // const criticalCss = `<link rel="stylesheet" type="text/css" media="screen" href="/_critical.scss.css?1670417681">`;
            const criticalCss = $('link[href*="critical.scss"]');
            // const afterCss = `<link rel="stylesheet" type="text/css" media="screen,print" href="/_after.scss.css?1670417683">;`;
            const afterCss = $('link[href*="_after.scss"]');
            const appCss = $('link[href*="app.css"]');
            const pcSearchComponent = defineCustomElement(PcSearchComponent);
            const mobileSearchComponent = defineCustomElement(MobileSearchComponent);

            console.log("registering");
            customElements.define("pc-search-component", pcSearchComponent);
            $(".search-input").after(
                $(`<pc-search-component></pc-search-component>`)
                    .css("display", "contents")
                    // .prop("id", "foxigy-plugin")
                    .prop("criticalCss", criticalCss.prop("href"))
                    .prop("afterCss", afterCss.prop("href"))
                    .prop("appCss", appCss.prop("href"))
            );

            customElements.define("mobile-search-component", mobileSearchComponent);
            $("#searchCollapse .frmsearchForm-wrap").after(
                $(`<mobile-search-component></mobile-search-component>`)
                    .css("display", "contents")
                    // .prop("id", "foxigy-plugin")
                    .prop("criticalCss", criticalCss.prop("href"))
                    .prop("afterCss", afterCss.prop("href"))
                    .prop("appCss", appCss.prop("href"))
            );

            provide("services", this._services);
        }

        // customElements.define("mobile-search-component", mobileSearchComponent);
        // $(".frmsearchForm-wrap").replaceWith("<mobile-search-component></mobile-search-component>");
    }
}

// eslint-disable-next-line
